import React from 'react';
import { ProfileBanner } from 'src/features/white-labels/ocean/profile/components/profile-banner';
import { EntityLayoutAvatar } from './entity-layout-avatar';
import { EntityLayoutContainer } from './entity-layout-container';
import { EntityLayoutDescription } from './entity-layout-description';
import { EntityLayoutSocials } from './entity-layout-socials';
import { EntityLayoutTitle } from './entity-layout-title';
import { IEntityLayout } from './entity-layout.types';

export const EntityLayout: IEntityLayout = ({ children }) => <>{children}</>;

EntityLayout.Banner = ProfileBanner;
EntityLayout.Avatar = EntityLayoutAvatar;
EntityLayout.Socials = EntityLayoutSocials;
EntityLayout.Container = EntityLayoutContainer;
EntityLayout.Title = EntityLayoutTitle;
EntityLayout.Description = EntityLayoutDescription;
